export type SubBannerKey =
  | "about"
  | "highlights"
  | "contact-us"
  | "beautiful-ways-to-use-your-pluswilla-sky-garden"
  | "the-real-timeline-of-setting-up-a-villa"
  | "the-science-behind-plus-willas-sky-garden"
  | "why-pluswilla-has-built-in-solar-power"
  | "tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore"
  | "unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti"
  | "5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore"
  | "top-reasons-to-invest-in-villas-plots-in-tvs-nagar"
  | "market-shopping-places-near-tvs-nagar"
  | "media"
  | "blog"
  | "gallery"
  | "default";

export type SubBannerConfigItem = {
  title: string;           // you can include <br/> using \n and render with whitespace-pre-line
  bg: string;              // background image path relative to ASSET_PREFIX
  shuttle?: string;        // optional shuttle image
  showShuttle?: boolean;   // toggle
  overlay?: string;        // optional tailwind overlay class override
  shuttlePosClass?: string;// optional position override for shuttle
};

export const SUBBANNER_CONFIG: Record<SubBannerKey, SubBannerConfigItem> = {
 
  "highlights": {
    title: "Highlights \n+Willa",
    bg: "/images/shuttle-bg.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  },

  "about": {
    title: "About \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  },
  "blog": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  },

  "beautiful-ways-to-use-your-pluswilla-sky-garden": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "the-real-timeline-of-setting-up-a-villa": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "the-science-behind-plus-willas-sky-garden": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "why-pluswilla-has-built-in-solar-power": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "top-reasons-to-invest-in-villas-plots-in-tvs-nagar": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "market-shopping-places-near-tvs-nagar": {
    title: "Blog \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 

  "media": {
    title: "Media \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 
  "gallery": {
    title: "Gallery \n+Willa",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 

  "contact-us": {
    title: "Contact Us \n+Willa",
    bg: "/images/shuttle-bg.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  }, 

  default: {
    title: "Page Title",
    bg: "/images/about-subban.webp",
    showShuttle: true,
    shuttle: "/images/space-shuttle.png",
  },
  
};
